import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        root: {},
        subFormDetails: {
            width: '40%',
            height: '47vh',
        },
    });

export default styles;
